import Image from "next/image";
import classNames from "classnames";

const AmenityCard = ({ amenity, className="" }) => {
  return (
    <>
      <div className={classNames("w-auto sm:w-44 md:w-44 lg:w-44 xl:w-44", className)}>
        <Image
          src={amenity.icon.url}
          width={amenity.icon.width}
          height={amenity.icon.height}
          alt="icon"
        />
        <div className=" flex mt-5">
        <h3 className="font-title text-main-blue text-[14px] lg:text-[18px]">{amenity.name}</h3>
        </div>

        <span className="font-text text-main-gray text-[12px] lg:text-[14px]">
          {amenity.description}
        </span>
      </div>
      
    </>
  );
};

export default AmenityCard;
